import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Invitation } from './invitation';

@Component({
  selector: 'app-options-component',
  templateUrl: './invitation-options.component.html',
  styleUrls: ['./invitations-options.component.scss']
})
export class InvitationOptionsComponent implements OnInit {
  isEditable: boolean;

  @Input()
  public rowData: Invitation;
  @Input()
  public value: string | number;

  @Output() inactivate: EventEmitter<any> = new EventEmitter<any>();
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendInvite: EventEmitter<any> = new EventEmitter<any>();
  @Output() save: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    this.isEditable = this.value === 'Draft';
  }

  doInactivate() {
    this.inactivate.emit(this.rowData);
  }

  doDelete() {
    this.delete.emit(this.rowData);
  }

  doSendInvite() {
    this.sendInvite.emit(this.rowData);
  }

  doSave() {
    console.log(this.rowData, this.value)
    this.save.emit(this.rowData);
  }

  isStatusPending(): boolean {
    return this.rowData && this.rowData.status === 'PENDING';
  }

  isStatusActive(): boolean {
    return this.rowData && this.rowData.status === 'ACTIVE';
  }
}
